import { cn } from "@/lib/utils";

type PagePlaceholderProps = {
    title: string;
    description?: string;
    icon?: React.ReactNode;
    actions?: React.ReactNode;
    testId?: string;
    className?: string;
};

/**
 * Shared empty-state / scaffold body for pages during early build stages.
 * Renders a centered card with title + description + optional actions.
 * Individual pages provide their own layout chrome (hero, filters, etc.)
 * and use this only when a section is intentionally empty.
 */
export function PagePlaceholder({
    title,
    description,
    icon,
    actions,
    testId,
    className,
}: PagePlaceholderProps) {
    return (
        <div
            data-testid={testId}
            className={cn(
                "mx-auto flex w-full max-w-xl flex-col items-center justify-center rounded-2xl border border-dashed border-border/70 bg-muted/30 px-6 py-14 text-center",
                className,
            )}
        >
            {icon ? (
                <div className="mb-4 grid h-14 w-14 place-items-center rounded-2xl bg-brand/10 text-brand">
                    {icon}
                </div>
            ) : null}
            <h3 className="text-xl font-semibold text-foreground">{title}</h3>
            {description ? (
                <p className="mt-2 max-w-sm text-sm text-muted-foreground">
                    {description}
                </p>
            ) : null}
            {actions ? <div className="mt-6">{actions}</div> : null}
        </div>
    );
}

export default PagePlaceholder;
